import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActiveScreensService } from '../shared/_services/active-screens.service';
@Component({
    selector: 'gtw-screens',
    templateUrl: './screens.component.html',
    styleUrls: ['./screens.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ScreensComponent implements OnInit {

  @Output('load-screens') showScreensEvent = new EventEmitter<any>();

  activeScreenKeys: Array<any> = [];
  isShowing = false;

  constructor(private activeScreenService: ActiveScreensService) { }

  ngOnInit(): void {
  }

  setActiveScreens(){
    this.activeScreenKeys = [];
    this.activeScreenKeys = (this.activeScreenService.getActiveScreens() || []).filter((screen: any) => !!screen);
    this.isShowing = !this.isShowing;
  }

  loadScreen(screen : any, i: number){
    if (!screen) {
      return;
    }
    this.activeScreenService.clickScreen(i);
    this.showScreensEvent.emit(screen);
  }

  goBack(){
    const screen = this.activeScreenService.goBack();
    this.showScreensEvent.emit(screen);
  }

  trackByMethod(index:number, screen:any){
    if (!screen) {
      return index;
    }
    return screen.id ?? screen.SCREEN_KEY ?? screen.screenKey ?? screen.key ?? index;
  }
  hideScreenList(){
    this.isShowing =false;
  }

}
